window.documentIconFormatter = function(value, row) {
    let html = '';
    if (can('documents')) {
        html += '<a href="'+row.action_show+'">';
        html += '<i class="fal fa-folder icon-document fa-2x"></i>';
        html += '</a>';
    } else {
        html += '<i class="fal fa-folder icon-document fa-2x"></i>';
    }
    return html;
};
